module.exports = __webpack_public_path__ + "img/btn_catalog_arrow_r.0ab6105c.svg";